import { useAppDispatch } from "@/app/hooks";
import { deleteChannel } from "@/features";
import { toastify } from "@/utils";
import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type Props = {
  isOpen: boolean;
  selectedId: number;
  onSuccess: () => void;
  toggle: () => void;
};

export const DeleteChannel = ({
  isOpen,
  selectedId,
  onSuccess,
  toggle,
}: Props) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onDelete = async () => {
    setIsSubmitting(true);
    try {
      await dispatch(deleteChannel(selectedId)).unwrap();
      toastify("Channel has been deleted successfully", "success");
      onSuccess();
    } catch (error) {
      console.log("error: ", error);
      toastify("An error occurred. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        <p>
          Are you sure want to <span className="fw-bold">DELETE</span> this
          channel?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={isSubmitting}>
          Close
        </Button>
        <Button color="danger" onClick={onDelete} disabled={isSubmitting}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
